import React, { Component } from 'react';
import { VictoryBar, VictoryPie, VictoryTheme } from 'victory';
import Collapsible from 'react-collapsible';
import { observer, inject } from 'mobx-react';
import '../App.css';

class Survey1 extends Component {
  handleClick = (event) => {
    var elmnt = document.getElementById('head');
    elmnt.scrollIntoView();
    this.props.StateStore.changeRoute('default');
  };

  render() {
    return (
      <div className='survey1'>
        <ul className='left-alignment'>
          <li className='q'>
            <Collapsible
              trigger={
                <h4>
                  Do you think the Government of India should have given more
                  time for you to prepare prior to imposing lockdown
                  <span className='highlight'> ?</span>
                </h4>
              }
            >
              <div className='result'>
                <VictoryPie
                  data={[
                    { x: 'Yes', y: 65 },
                    { x: 'No', y: 20 },
                    { x: 'No opinion/ Unsure', y: 15 },
                  ]}
                  labels={({ datum }) => `${datum.x}: ${datum.y}`}
                  // colorScale={['tomato', 'orange', 'cyan']}
                  innerRadius={50}
                  padding={55}
                  padAngle={5}
                  style={{
                    data: {
                      fillOpacity: 1,
                      stroke: '#252525',
                      strokeWidth: 1,
                    },
                    labels: {
                      fontSize: 12,
                      fill: '#f4f4f4',
                    },
                  }}
                  theme={VictoryTheme.material}
                  animate={{ duration: 2000 }}
                />
              </div>
            </Collapsible>
          </li>
          <li>
            <Collapsible
              trigger={
                <h4>
                  What was the single biggest disruption that the lockdown
                  caused to your daily life in Bhubaneswar
                  <span className='highlight'> ?</span>
                </h4>
              }
            >
              <div className='result'>
                <VictoryBar
                  data={[
                    { x: 'Social Distancing', y: 75 },
                    { x: 'Workplace Closure', y: 50 },
                    { x: 'Working Frome Home', y: 100 },
                    { x: 'Travel Ban', y: 120 },
                    { x: 'Income Loss', y: 220 },
                    { x: 'Access to healthcare', y: 150 },
                    { x: 'Online Delivery', y: 75 },
                    { x: 'No hired help', y: 100 },
                    { x: 'Other', y: 70 },
                  ]}
                  x='x'
                  y='y'
                  colorScale={['tomato', 'orange', 'cyan']}
                  labels={({ datum }) => `${datum.x}: ${datum.y}`}
                  padding={70}
                  width={600}
                  scale={{ x: 'linear', y: 'linear' }}
                  barRatio={0.8}
                  style={{
                    data: {
                      fillOpacity: 1,
                      fill: '#ee274e',
                      stroke: '#252525',
                      strokeWidth: 1,
                    },
                    labels: {
                      fontSize: 15,
                      fill: '#f4f4f4',
                    },
                  }}
                  theme={VictoryTheme.material}
                  animate={{ duration: 2000 }}
                />
              </div>
            </Collapsible>
          </li>
          <li>
            <Collapsible
              trigger={
                <h4>
                  Do you support the Government’s decision to extend the
                  lockdown to May 3rd<span className='highlight'> ?</span>
                </h4>
              }
            >
              <div className='result'>
                <VictoryPie
                  data={[
                    { x: 'Yes', y: 65 },
                    { x: 'No', y: 20 },
                    { x: 'No opinion/Too early to tell', y: 15 },
                  ]}
                  labels={({ datum }) => `${datum.x}: ${datum.y}`}
                  colorScale={['tomato', 'orange', 'cyan']}
                  innerRadius={0}
                  padding={50}
                  padAngle={2}
                  style={{
                    data: {
                      fillOpacity: 1,
                      stroke: '#252525',
                      strokeWidth: 1,
                    },
                    labels: {
                      fontSize: 10,
                      fill: '#f4f4f4',
                    },
                  }}
                  theme={VictoryTheme.material}
                  animate={{ duration: 2000 }}
                />
              </div>
            </Collapsible>
          </li>
          <li>
            <Collapsible
              trigger={
                <h4>
                  What are your top three concerns post-lockdown in Bhubaneswar
                  <span className='highlight'> ?</span>
                </h4>
              }
            >
              <div className='result'>
                <VictoryPie
                  data={[
                    { x: 'Exposure to virus', y: 45 },
                    {
                      x: 'Distancing',
                      y: 20,
                    },
                    { x: 'Economic impact', y: 38 },
                    { x: 'Travelling', y: 27 },
                    { x: 'Crime Increase', y: 5 },
                    { x: 'Traffic Increase', y: 12 },
                    {
                      x: 'Medical Visit',
                      y: 18,
                    },
                    {
                      x: 'Transportation',
                      y: 19,
                    },
                    { x: 'Inflation', y: 23 },
                    { x: 'Other', y: 3 },
                  ]}
                  labels={({ datum }) => `${datum.x}:${datum.y}`}
                  innerRadius={0}
                  padding={100}
                  style={{
                    data: {
                      fillOpacity: 1,
                      stroke: '#252525',
                      strokeWidth: 1,
                    },
                    labels: {
                      fontSize: 11,
                      fill: '#f4f4f4',
                    },
                  }}
                  theme={VictoryTheme.material}
                  animate={{ duration: 2000 }}
                />
              </div>
            </Collapsible>
          </li>
        </ul>
        <button className='homeButton' onClick={this.handleClick}>
          Home
        </button>
      </div>
    );
  }
}

export default inject('StateStore')(observer(Survey1));
